import { VStack } from "@design-system/VStack/VStack";
import { SchedulePreviewTable } from "./SchedulePreviewTable";
import { ScheduleApplyPreviewState } from "./useScheduleApplyPreview";
import styles from "./ScheduleApplyModal.module.scss";

const PREVIEW_COLUMNS = [
    { id: "period", header: "Period" },
    { id: "date", header: "Recognition date" },
    { id: "amount", header: "Amount", isNumeric: true },
];

function renderPreviewResult(preview: ScheduleApplyPreviewState) {
    if (preview.errorMessage !== null) {
        return <p className={styles.previewError}>{preview.errorMessage}</p>;
    }
    if (preview.rows.length === 0) {
        return <p className={styles.helperText}>Building preview...</p>;
    }
    return (
        <SchedulePreviewTable columns={PREVIEW_COLUMNS} rows={preview.rows} />
    );
}

export const ScheduleApplyPreview = ({
    preview,
}: {
    preview: ScheduleApplyPreviewState;
}) => {
    if (!preview.isRequested) {
        return null;
    }
    return (
        <VStack gap={8} className={styles.preview}>
            <span className={styles.fieldLabel}>Recognition preview</span>
            {renderPreviewResult(preview)}
        </VStack>
    );
};
